import React from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import Home from "./FrontEnd/Home/Home";
import { PaymentList } from "./FrontEnd/Payments/PaymentList";
import { SettlementList } from "./FrontEnd/Settlements/SettlementList";
import { BillingList } from "./FrontEnd/Billing/BillingList";
import BillView from "./FrontEnd/Billing/BillView";
import FabCredit from "./FrontEnd/FabCredit/FabCredit";
import FranchiseRegistration from "./FrontEnd/Registration/Franchise";
import FabCreditDetail from "./FrontEnd/FabCredit/FabCreditDetail";
import { FranchiseList } from "./FrontEnd/Registration/Franchise/FranchiseList";
import { Product } from "./FrontEnd/Product/Product";
import { ProductList } from "./FrontEnd/Product/ProductList";
import { Service } from "./FrontEnd/Service/Service";
import { ServiceList } from "./FrontEnd/Service/ServiceList";
import { WalkInOrder } from "./FrontEnd/Orders/NewWalkInOrder/WalkInForm";
import { PickupOrder } from "./FrontEnd/Orders/PickupOrders/PickupForm";
import { ServiceProductMapping } from "./FrontEnd/ServiceProductMapping/ServiceProductMapping";
import { ServiceProductMappingList } from "./FrontEnd/ServiceProductMapping/ServiceProductMappingList";
import { AddOnService } from "./FrontEnd/Service/AddOnService";
import { AddOnServiceList } from "./FrontEnd/Service/AddOnServiceList";
import { DeliveredList } from "./FrontEnd/Delivery/DeliveredList";
import { PaidList } from "./FrontEnd/Payments/PaidList";
import { PaymentTab } from "./FrontEnd/Payments/PaymentTab";
import { FranchiseUser } from "./FrontEnd/Registration/User";
import { CustomerList } from "./FrontEnd/Customer/CustomerList";
import { CustomerRegister } from "./FrontEnd/Customer/Customer";
import { ProductServiceMapping } from "./FrontEnd/ProductServiceMapping/ProductServiceMapping";
import { ProductServiceMappingList } from "./FrontEnd/ProductServiceMapping/ProductServiceMappingList";
import { Rider } from "./FrontEnd/Rider/Rider";
import { RiderList } from "./FrontEnd/Rider/RiderList";
import { PickupOrderList } from "./FrontEnd/Orders/PickupOrders/PickupOrderList";
import LoyaltyRedeemPage from "./FrontEnd/Loyalty/pages/Radeem";
import LoyaltyRulesPage from "./FrontEnd/Loyalty/pages/Rules";
import LoyaltyReferralPage from "./FrontEnd/Loyalty/pages/Referel";
import { LoyaltyRule } from "./FrontEnd/Loyalty/pages/CreateRules";
import { FranchiseUsersList } from "./FrontEnd/Registration/User/FranchiseUsersList";

interface PrivateRouteProps {
  token: string | null;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ token }) => {
  if (!token) {
    return token ? <Outlet /> : <Navigate to="/login" />;
  }

  return (
    <Routes>
      {/* order management */}
      <Route path="/home" element={<Home />} />
      <Route path="/new-walk-in-order/:id?" element={<WalkInOrder />} />
      <Route path="/pickup-order/:id?" element={<PickupOrder />} />
      <Route path="/pickup-order/list" element={<PickupOrderList />} />

      {/* payment */}
      <Route path="/payment/list" element={<PaymentList />} />
      <Route path="/paid/list" element={<PaidList />} />
      <Route path="/payment" element={<PaymentTab />} />
      <Route path="/user/registration" element={<FranchiseUser />} />

      <Route path="/settlement" element={<SettlementList />} />
      <Route path="/bill" element={<BillingList />} />
      <Route path="/billing/:id" element={<BillView />} />

      <Route path="/fab-credit" element={<FabCredit />} />
      <Route path="/details/fab-credit" element={<FabCreditDetail />} />

      {/*franchisee user management */}
      <Route path="/user/registration/:id?" element={<FranchiseUser />} />
      <Route path="/user/list" element={<FranchiseUsersList />} />

      {/* franchise management */}
      <Route path="/franchise/:id?" element={<FranchiseRegistration />} />
      <Route path="/franchise/list" element={<FranchiseList />} />

      {/* product management */}
      <Route path="/product/:id?" element={<Product />} />
      <Route path="/product/list" element={<ProductList />} />

      {/* service management */}
      <Route path="/service/:id?" element={<Service />} />
      <Route path="/service/list" element={<ServiceList />} />

      {/* service to product map */}
      <Route path="/service-product-map/:id?" element={<ServiceProductMapping />} />
      <Route
        path="/service-product-map/list"
        element={<ServiceProductMappingList />}
      />

      {/* product to service map */}

      <Route path="/product-service-map" element={<ProductServiceMapping />} />
      <Route
        path="/product-service-map/list"
        element={<ProductServiceMappingList />}
      />

      <Route path="/add-on-service/create" element={<AddOnService />} />
      <Route path="/add-on-service/:id" element={<AddOnService />} />
      <Route path="/add-on-service/list" element={<AddOnServiceList />} />
      <Route path="/delivered/list" element={<DeliveredList />} />

      {/* Customer management */}
      <Route path="/customer/:id?" element={<CustomerRegister />} />
      <Route path="/customer/list" element={<CustomerList />} />

      {/* Rider management */}
      <Route path="/rider/:id?" element={<Rider />} />
      <Route path="/rider/list" element={<RiderList />} />

      {/* Loyalty management */}
      <Route path="/loyalty/points/radeem" element={<LoyaltyRedeemPage />} />
      <Route path="/loyalty/:id?" element={<LoyaltyRule />} />
      <Route path="/loyalty/rules" element={<LoyaltyRulesPage />} />
      <Route path="/loyalty/referel" element={<LoyaltyReferralPage />} />
    </Routes>
  );
};

export default PrivateRoute;
